import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({ providedIn: 'root' })
export class Entityservice {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common/entity';
  post(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/addentity`, payload); 
  }
  modify(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/modifyentity`, payload); 
  }
  getall_list(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getentitylist/`, payload);
  }
  getDataView_byId(entityid: String,selectedorgid: String): Observable<any> {

    return this.httpClient.get(`${this.baseURL}/getentitybyid/${entityid}/${selectedorgid}`);
  }

  getentitytypeList(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/forlist/entitytype`);
  }
  entityDataExcel(payload) { 

     return this.httpClient.post(`${this.baseURL}/entityDataExcel`, payload, { responseType: 'blob' });
  }
  excelUploadFormat() {

    return this.httpClient.get(`${this.baseURL}/bulkuploadTempExcel`, { responseType: 'blob' });
  }
  getentityforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/entitydata`);
  }

  legalchange(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/legalchange`, payload);
  }

  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
  }

  getGroup(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getgroup`);
  }

  deleteEntity(payload): Observable<any> {
    return this.httpClient.delete(`${this.baseURL}/deleteentity`, { params: payload });
  }

  getOrganisation(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getorganisations`);
  }

   checkDuplicateCinInModify(payload): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/checkduplicatecinmodify`, { params: payload });
  }

  checkDuplicateCin(payload): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/checkduplicatecin`, { params: payload });
  }
}